import React from 'react';
import { FadeIn } from './FadeIn';
import { DumbbellIcon, AppleIcon, MoonIcon, GiftIcon, CheckCircle2Icon } from 'lucide-react';
export function TriadAndBonuses() {
  const triad = [{
    icon: <DumbbellIcon className="w-8 h-8 text-white" data-id="element-104" />,
    title: 'Fuerza Específica',
    desc: 'Programa de 24 semanas. Mejora la economía de carrera hasta un 8% y reduce lesiones a la mitad.'
  }, {
    icon: <AppleIcon className="w-8 h-8 text-white" data-id="element-105" />,
    title: 'Nutrición Aplicada',
    desc: 'Timing de macros, carga de carbohidratos y estrategia de geles sin mitos ni modas.'
  }, {
    icon: <MoonIcon className="w-8 h-8 text-white" data-id="element-106" />,
    title: 'Recuperación Activa',
    desc: 'Protocolos de sueño, movilidad y HRV. Donde ocurre la supercompensación real.'
  }];
  const bonuses = ['Kit de Planificación Pro (Plantillas Excel)', 'Sistema de Gestión de Grupos', 'Running Pro Academy (Módulos en Video)', 'Mentoría y Comunidad VIP', 'Guía de Psicología del Corredor'];
  return <section className="py-24 px-4 bg-brand-surface border-t border-brand-muted/10" data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        {/* The Triad */}
        <FadeIn className="mb-20" data-id="element-109">
          <div className="text-center mb-16" data-id="element-110">
            <h2 className="text-brand-volt font-bold tracking-widest text-sm mb-4" data-id="element-111">
              LA TRÍADA DEL CUERPO COMPLETO
            </h2>
            <h3 className="text-4xl sm:text-5xl font-black text-white" data-id="element-112">
              EL RUNNING NO ES <br data-id="element-113" /> SOLO SUMAR KILÓMETROS
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-114">
            {triad.map((item, i) => <div key={i} className="bg-brand-volt p-8 transform hover:-translate-y-2 transition-transform" data-id="element-115">
                <div className="mb-6" data-id="element-116">{item.icon}</div>
                <h4 className="text-2xl font-bold text-white mb-3" data-id="element-117">
                  {item.title}
                </h4>
                <p className="text-white/90 font-medium leading-relaxed normal-case" data-id="element-118">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>

        {/* Bonuses */}
        <FadeIn delay={0.2} data-id="element-119">
          <div className="bg-brand-dark border border-brand-muted/20 p-8 sm:p-12" data-id="element-120">
            <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-121">
              <div className="flex-1" data-id="element-122">
                <div className="inline-flex items-center gap-2 text-brand-volt font-bold tracking-widest text-sm mb-6" data-id="element-123">
                  <GiftIcon className="w-5 h-5" data-id="element-124" />
                  BONUS EXCLUSIVOS
                </div>
                <h3 className="text-3xl sm:text-4xl font-black text-white mb-6" data-id="element-125">
                  TODO LO QUE NECESITÁS <br data-id="element-126" /> PARA IMPLEMENTAR HOY
                </h3>
                <p className="text-gray-400 text-lg normal-case mb-8" data-id="element-127">
                  No te dejamos solo con la teoría. Te damos las herramientas
                  exactas para que apliques el sistema desde tu próxima clase.
                </p>
              </div>

              <div className="flex-1 w-full" data-id="element-128">
                <ul className="space-y-4" data-id="element-129">
                  {bonuses.map((bonus, i) => <li key={i} className="flex items-start gap-4 bg-brand-surface p-4 border border-brand-muted/10" data-id="element-130">
                      <CheckCircle2Icon className="w-6 h-6 text-brand-volt shrink-0 mt-0.5" data-id="element-131" />
                      <span className="text-white font-medium normal-case" data-id="element-132">
                        {bonus}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}